import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import AuthRoute from './AuthRoute';

const DashboardRouter = ({ routes }) => (
  <Switch>
    {routes.map((route, key) => {
      if (route.redirect) {
        return <Redirect from={route.path} to={route.pathTo} key={key} />;
      }
      if (route.collapse) {
        return route.views.map((viewRoute, index) => (
          <AuthRoute {...viewRoute} key={`${key}-${index}`} />
        ));
      }
      return <AuthRoute {...route} key={key} />;
    })}
  </Switch>
);

export default DashboardRouter;
